import * as React from "react";
import Popup from "react-popup";

let currentElement = null;

export function RestoreFocus() {
    if (currentElement) {
        currentElement.focus();
    }
}

export function PopupSetButtonFocus() {
    currentElement = document.activeElement;

    setTimeout(() => {
        const defaultButton = document.getElementsByClassName("mm-popup__btn")[0];

        if (defaultButton) {
            defaultButton.focus();
        }
    }, 150);
}

// Exibe uma mensagem informativa para o usuário, sem tratar o retorno.
export function showMessage(mensagem) {
    return new Promise((resolve) => {
        showInformation(mensagem, resolve);
    });
}

// Trata erros das chamadas à API, direcionando o usuário conforme o status:
// 403 => token restrito à troca de senha (senha expirada) - tela de alteração de senha
// 401 => sessão inexistente/expirada - tela de login
export async function tratarErroApi(error, history) {
    console.log(error);

    const status = error?.response?.status;

    if (status === 403) {
        await showMessage("Sua senha de acesso expirou.\r\nInforme uma nova senha para continuar.");
        history.push("/AlterarSenha");
        return;
    }

    if (status === 401) {
        history.push("/");
        return;
    }

    showMessage("Serviço indisponível, tente novamente mais tarde.");
}

export function showInformation(message, onOk) {
    PopupSetButtonFocus();

    let resolved = false;
    const mySpecialPopup = Popup.register({
        title: "Aviso",
        content: message,
        onClose: () => {
            if (!resolved && typeof onOk === "function") onOk();
        },
        buttons: {
            right: [
                {
                    text: "Ok",
                    action: function () {
                        if (typeof onOk === "function") onOk();
                        resolved = true;
                        Popup.close();
                        RestoreFocus();
                    },
                },
            ],
        },
    });

    setPopupHtml(message);

    Popup.queue(mySpecialPopup);
}

// Exibe uma confirmação (Sim/Não) para o usuário, retornando Promise<boolean>.
// Pode ser usada como substituto do window.confirm.
export function showConfirm(titulo, mensagem) {
    return new Promise((resolve) => {
        PopupSetButtonFocus();

        let resolved = false;

        const finish = (result) => {
            if (!resolved) {
                resolved = true;
                resolve(result);
            }
        };

        const mySpecialPopup = Popup.register({
            title: titulo,
            content: mensagem,
            onClose: () => finish(false),
            buttons: {
                right: [
                    {
                        text: "Não",
                        action: function () {
                            // resolve antes do close, pois Popup.close() dispara onClose (finish(false))
                            finish(false);
                            Popup.close();
                        },
                    },
                    {
                        text: "Sim",
                        action: function () {
                            // resolve antes do close, pois Popup.close() dispara onClose (finish(false))
                            finish(true);
                            Popup.close();
                        },
                    },
                ],
            },
        });

        setPopupHtml(mensagem);

        Popup.queue(mySpecialPopup);
    });
}

function setPopupHtml(mensagem) {
    setTimeout(() => {
        if (mensagem) {
            mensagem = mensagem.replace(/\r?\n/g, "<br />");

            const element = document.getElementsByClassName("mm-popup__box__body")[0];
            if (element) {
                element.innerHTML = mensagem;
            }
        }
    }, 150);
}

export function validaEmail(email) {
    const regex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9]))$/i;
    return regex.test(email);
}
